import React from 'react'
import { Box, Chip } from '@mui/material'

import AIIcon from '~assets/icons/AIIcon'
import { ensureHash, getCustomColorChipStyle, tagColors } from '~utils/colorUtils'

interface TagProps {
  tag: string
  size?: 'small' | 'medium'
  color?: string
  textColor?: string
  onDelete?: () => void
  calculated?: boolean
}

const Tag: React.FC<TagProps> = ({
  tag,
  size = 'small',
  color,
  textColor,
  onDelete,
  calculated = false,
}) => {
  const randomColor = React.useMemo(
    () => tagColors[Math.floor(Math.random() * tagColors.length)],
    [],
  )
  const colorStart = color ? ensureHash(color) : undefined
  const finalColor = colorStart || randomColor
  const fontSize = size === 'medium' ? '0.95rem' : '0.75rem'
  const chipStyle = getCustomColorChipStyle(finalColor)
  const contrastTextColor = textColor || chipStyle.text

  return (
    <Chip
      icon={
        calculated ? (
          <Box
            className='flex-vh-align'
            sx={{
              py: 1,
              pl: 1,
            }}
          >
            <AIIcon color={contrastTextColor} />
          </Box>
        ) : undefined
      }
      label={tag}
      size={size}
      onDelete={onDelete}
      sx={{
        backgroundColor: chipStyle.background,
        color: contrastTextColor,
        '& .MuiChip-label': {
          fontSize: fontSize,
        },
        '& .MuiChip-deleteIcon': {
          color: contrastTextColor,
          '&:hover': {
            color: contrastTextColor,
            opacity: 0.7,
          },
        },
      }}
    />
  )
}

export default Tag
